<div mat-dialog-content>
    <img 
        src="assets/images/iconos/hover_numero_formulario.png">
</div>
    <div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cerrar</button>
</div>
